export default __webpack_public_path__ + "static/media/no-wait-dependent-care-fsa.78207767.svg";